import { render, staticRenderFns } from "./TextDetail.vue?vue&type=template&id=56344273&scoped=true"
import script from "./TextDetail.vue?vue&type=script&lang=js"
export * from "./TextDetail.vue?vue&type=script&lang=js"
import style0 from "./TextDetail.vue?vue&type=style&index=0&id=56344273&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56344273",
  null
  
)

export default component.exports